import styles from "./Inicio.module.css";
import "../../Shared/Css/Shared.css";
import Banner from "./Banner/Banner";
import Infos from "./Infos/Infos";
import Escolher from "./Escolher/Escolher";
import Comecar from "./Comecar/Comecar";

function Inicio() {
    return (
        <div>
            <div className={`${styles.content} ${styles.banner}`}>
                <div className={`${styles.size} ${styles.inicio}`}>
                    <Banner />
                </div>
            </div >
            <div className={`${styles.content} ${styles.infos}`}>
                <div className={styles.size}><Infos /></div>
            </div>
            <div className={`${styles.content} ${styles.escolher}`}>
                <div className={`${styles.size}`}>
                    <Escolher />
                </div>
            </div>
            <div className={`${styles.content} ${styles.comecar}`}>
                <div className={`${styles.size} ${styles.comecar}`}>
                    <Comecar />
                </div>
            </div>
        </div>
    );
}

export default Inicio;
